import { SVGProps, Ref, forwardRef } from 'react';

export const ExclamationTriangleFilledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.675 3.32 1.23 11.441C.24 13.248-.255 14.152.131 14.826s1.399.674 3.423.674h8.892c2.024 0 3.037 0 3.423-.674s-.109-1.578-1.098-3.385l-4.446-8.12C9.295 1.44 8.78.5 8 .5c-.78 0-1.295.94-2.325 2.82m1.63 6.95v-5h1.4v5zm.7.899a.933.933 0 1 1 0 1.866.933.933 0 0 1 0-1.866"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
ExclamationTriangleFilledSize16Glyph.displayName = 'ExclamationTriangleFilledSize16Glyph';
